import React, { useEffect } from "react";
import { ROUTES } from "./Routes";
import Maintenance from "../popups/Maintenance";
import { createModal } from "../hooks/createModal";
import Cookies from 'js-cookie';
import { showError } from "../ui/Message";
import Workstation from "../popups/Workstation";
import Help from "../popups/Help";
import dayjs from "dayjs";
import { getSignal, setSignal } from "../App";
import { requireLogin, showConfirm, showInfo, showLogin } from "./Utils";
const autobahn = window.autobahn;


// if (!Cookies.get("ticket")) {
//     Cookies.set("ticket", "jp_GBOCnQexWRCXRBpxySW558i8W", { expires: 365, domain: ".bookmanager.com" });
// }

// if(!Cookies.get("socket_url")){
//     Cookies.set("socket_url", "wss://bmo-1.bookmanager.com/ws/", { expires: 365, domain: ".bookmanager.com" });
// }



// Cloud
const socket_url = (Cookies.get("socket_url")) ? Cookies.get("socket_url") : "";
const store_id = "11";
// const ticket = (Cookies.get("ticket")) ? Cookies.get("ticket") : "jp_GBOCnQexWRCXRBpxySW558i8W";

// Cloud Test000
// const socket_url = "wss://bmo-1.bookmanager.com/ws/";
// const ticket = "test000";4
// const store_id = "101069";

// Tobias
// const socket_url = (Cookies.get("socket_url")) ? Cookies.get("socket_url") : "ws://192.168.0.50:5001/ws";
// const store_id = "11";
// const ticket = "bU5s9b8BJaDkN0-W5XhPCPRBvEt4";

// const socket_url = "ws://192.168.0.50:5001/ws";
// const ticket = "bU5s9b8BJaDkN0-W5XhPCPRBvEt4";s
// const store_id = "101069";



let interval = 0;
let bouncing = 0;
let last_call = "";


var msgpser = new autobahn.serializer.MsgpackSerializer();
var jsonser = new autobahn.serializer.JSONSerializer();

const showMaintenance = (res) => {
    window.maintenance_mode = true;
    if (window.bm_state.value === ROUTES.GLOBAL.MAINTENANCE) {
        return;
    }
    let _origin = window.bm_state.value;
    window.bm_state.value = ROUTES.GLOBAL.MAINTENANCE;
    createModal({
        alert: true,
        component: <Maintenance res={res} route={ROUTES.GLOBAL.MAINTENANCE} />, closable: false, title: <>Maintenance</>, callback: (_filter) => {

            window.bm_state.value = _origin;
        }
    })
}

// require_login = forces a login
// require_clerk_code = gives option to login
// force_clerk_code = must input clerk code every time
const authRunCall = (_path, _params, _callback) => {
    let _signal = getSignal();

    if ((_params?.require_clerk_code && !_signal?.session?.clerk_code) || _params?.force_clerk_code || (_params?.require_login && !_signal?.session?.clerk_code)) {

        const isRequireLogin = !!_params?.require_login;
        const isForceClerk = !!_params?.force_clerk_code;


        showLogin({
            route: window.bm_state.value,
            login: isRequireLogin ? true : false,
            can_login: isRequireLogin ? false : (isForceClerk ? false : true),
            title: isRequireLogin
                ? "Login required"
                : (isForceClerk ? "Clerk code required" : "Login required"),
            signal: _signal,
            callback: (e) => {
                if (e) {
                    let _c = e;
                    if (e?.clerk_code) {
                        _c = e?.clerk_code;
                    }
                    runCall(_path, { ..._params, clerk_code: _c }, _callback);
                } else {

                    _callback(false, {
                        error: isRequireLogin
                            ? "Login required."
                            : (isForceClerk ? "Clerk code required." : "Login required.")
                    });
                }
            }
        });
    } else {

        if((_params?.require_clerk_code || _params?.require_login) && _signal?.session?.clerk_code){
            runCall(_path, { ..._params, clerk_code: _signal.session.clerk_code }, _callback);
        } else {
            runCall(_path, _params, _callback);
        }
        
    }
};



const runCall = (_path, _params, _callback) => {

    if (!window.ses.isOpen) { return; }





    const s = Date.now();
    window.ses.call(_path, [], _params).then(
        function (res) {
            const e = Date.now(); // End the timer
            const ms = e - s
            last_call = "";

            if (window.maintenance_mode) {
                window.maintenance_mode = null;
                window.location.reload();
                return;
            }

            console.log("%c pubCall: " + _path, "color:yellow;", "(" + ms + "ms)(" + window.bm_state.value + ")", { call: _params, result: res });
            _callback(true, res);
        }
    ).catch(
        function (res) {
            last_call = "";
            console.log("%c pubCall: " + _path, "color:red;", "(" + window.bm_state.value + ")", "(" + res.error + ")", { call: _params, result: res });
            if (res.error === "com.bmo.maintenance") {

                showMaintenance(res);
            } else if (res.error === "com.bmo.seat_issue") {
                alert("Seat issue!!");
            } else {
                _callback(false, res);
            }

        }
    )
}


export const pubCall = (_method = "", _params = {}, _callback = () => { }, debounce = 0) => {

    if (!window.ses) {
        console.log("No pubsub sesison")
        return
    }

    let _path = "com." + window.credentials.store_id + "." + _method;

    let obj = {
        "action": _path,
        "params": _params,
    }

    // Stop double calls...
    if ((last_call) && JSON.stringify(obj) === last_call) {
        //console.log("is sending...")
        return;
    }
    last_call = JSON.stringify(obj);
    setTimeout(() => { last_call = false }, 1)

    _params.session_id = window.credentials.ticket;
    _params.subscription_id = parseInt(window.subscription_id);

    if (debounce) {
        if (!bouncing) {
            authRunCall(_path, _params, _callback);
            bouncing = 1;
        }
        clearTimeout(bouncing);
        bouncing = setTimeout(() => {
            authRunCall(_path, _params, _callback);
            bouncing = 0;
        }, debounce)

    } else {
        authRunCall(_path, _params, _callback);
    }
}

export const pubCallAsync = (method, params = {}) => {
    return new Promise((resolve, reject) => {
        pubCall(method, params, (_s, _r) => {
            if (_s) {
                resolve(_r);
            } else {
                return resolve(true)
            }
        });
    });
};

export const pubSub = (_uri = "", _params = {}, _callback = () => { }, _global = false) => {
    if (!window.ses) {
        console.log("No pubsub sesison");
        return
    }

    // Initialize the subscribed array if not already set
    if (!Array.isArray(window.subscribed)) {
        window.subscribed = [];
    }


    const _path = (_global) ?  `com.${_uri}` : `com.${window.credentials?.store_id ?? "default"}.${_uri}`;

    // Check if already subscribed
    if (window.subscribed.includes(_path)) {
        return;
    }

    if (window.ses.subscriptions.length > 0 && window.ses.subscriptions[0].find(item => item.topic === _path)) {
        return;
    }

    window.ses.subscribe(_path, typeof _callback === "function" ? (e, f) => {

        console.log("%c pubSub: " + _path, "color:grey;", { array: e, object: f });
        _callback(e, f)
    } : () => { })
        .then(() => {
            console.log(`Successfully subscribed to ${_uri}`);
        })
        .catch((error) => {
            console.error(`Failed to subscribe to ${_uri}:`, error);
            // Remove from subscribed list on failure
            window.subscribed = window.subscribed.filter(path => path !== _path);
        });

    // window.ses.subscribe(_path, _callback).then(() => {
    //     console.log("subscribed to " + _uri);
    // });
}




// export const pubSub = (_uri = "", _params = {}, _callback = () => {}) => {
//     if (!window.ses) {
//         console.error("No pubsub session");
//         return;
//     }

//     // Initialize the subscribed array if not already set
//     if (!Array.isArray(window.subscribed)) {
//         window.subscribed = [];
//     }

//     // Generate the subscription path
//     const _path = `com.${window.credentials?.store_id ?? "default"}.${_uri}`;

//     // Check if already subscribed
//     if (window.subscribed.includes(_path)) {
//         return;
//     }

//     // Add to subscribed list and subscribe
//     window.subscribed.push(_path);

//     window.ses.subscribe(_path, typeof _callback === "function" ? _callback : () => {})
//         .then(() => {
//             console.log(`Successfully subscribed to ${_uri}`);
//         })
//         .catch((error) => {
//             console.error(`Failed to subscribe to ${_uri}:`, error);
//             // Remove from subscribed list on failure
//             window.subscribed = window.subscribed.filter(path => path !== _path);
//         });
// };



const showDisconnect = () => {


    showInfo({
        controller: "",
        type: "danger",
        closeable : false,
        route: ROUTES.HELPERS.HELP,
        description: <div style={{ "textAlign": "center" }}>
            <div className="shim" />
            This station was disconnected because it's active on another device. <br /> Please ensure only one instance is running to avoid conflicts.
            <div className="shim" /><div className="shim" /><div className="shim" />
           

        </div>,
        title: "Station disconnected.",
        callback: (e) => {
            if (e) {

                const path = window.location.pathname;
                const path_id = path.split("/")[1];
                window.history.replaceState(null, '', '/' + path_id);
                window.location.reload();

            } else {
                const path = window.location.pathname;
                const path_id = path.split("/")[1];
                window.history.replaceState(null, '', '/' + path_id);
                window.location.reload();
            }
        }
    })


}


const fetchAndSubscribe = (signal = {}, setStatus = () => { }) => {
    pubCall("session.get", {}, (_status, _result) => {
        if (_status) {
  
            window.settings = _result;
            signal.value = { ...signal.value, "session": _result }
            window.credentials.store_name = _result.store_name;
            if(_result?.ms_info?.length){
                let _f = _result?.ms_info.find(item => item.san === _result?.store_san);
                if(_f){
                    window.credentials.store_name = _f.store_name;
                }
            }
            
            setStatus("connected");
            console.log("About to subscribe...")
            pubSub("work_station", {}, (_e, _f = {}) => {



                if (_f?.message?.data?.station === _result.station) {

                    window.idle_route = window.bm_state.value;
                    showDisconnect();
                }
            })
        }
    })

}


const setWorkStation = (signal = {}, setStatus = () => { }) => {
    window.bm_state.value = ROUTES.HELPERS.WORKSTATION;
    createModal({
        offset: [0, 0],
        component: <Workstation route={ROUTES.HELPERS.WORKSTATION} />, title: "Enter Workstation Number", closable: false, callback: (e) => {
            window.bm_state.value = (window.idle_route) ? window.idle_route : ROUTES.MAIN;
            window.idle_route = "";
            fetchAndSubscribe(signal, setStatus);
        }
    })

}


const PubSub = (props) => {

    const { signal = {}, status = "connecting", setStatus = () => { } } = props;

    useEffect(() => {


        // Tobias's auth thing... 
        const onChallenge = (_session, _method, _extra) => {
            console.log("autheticating " + _method);
            if (_method === "ticket") { return window.credentials.ticket; }
            console.log("Can't authenticate using '" + _method + "'");
        }

        // Connection
        const connection = new autobahn.Connection({
            url: (socket_url) ? socket_url : window.credentials.socket_url,
            realm: 'bookmanager',
            authmethods: ["ticket"],
            authid: window.credentials.store_id.toString(),
            onchallenge: onChallenge,
            serializers: [msgpser, jsonser]
        });

        const stationSub = (_s, _r) => {
            console.log(_s);
            console.log(_r);

        }

        // Open (Set window vars and create subscriptions)
        const onOpen = (session) => {
            window.ses = session;
            window.credentials.subscription_id = session.id;
            window.subscription_id = session.id;

            setWorkStation(signal, setStatus);

            // if (signal?.value?.session?.station) {
            //     fetchAndSubscribe(signal, setStatus); 
            // } else {
            //     setWorkStation(signal, setStatus);
            // }

        };

        // Function to handle when the connection is closed
        const onClose = (reason, details) => {
            console.log('WebSocket connection closed:', reason, details);
        };

        // Set up event listeners
        connection.onopen = onOpen;
        connection.onclose = onClose;

        // Open the connection
        connection.open();

        window.disconnectWamp = () => {
            if (connection.isOpen) {
                connection.close();
                console.log('Connection closed globally');
            }
        };

        window.reconnectWamp = () => {
            if (!connection.isOpen) {
                connection.open();
                console.log('Connection reopened globally');
            }
        };

        // Cleanup function to close the connection when the component unmounts
        return () => {

            window.ses = null;
            window.credentials.subscription_id = "";
            connection.close();
        };
    }, []);  // Run the effect only once when the component mounts

    return (<></>);
};

export default PubSub;